import { ChartSettingsT } from 'business/definitions';
import _ from 'lodash';
import { conceptionAvailableVizTypes } from 'routes/Explore/components/Settings/components/ConceptionAccordion/helpers/definitions';

const areConceptionColumnsCompatibleWithChart = (
    chartConception: ChartSettingsT['chartConception'],
    columns: ResponseColumnT[],
) => {
    if (!chartConception) {
        return false;
    }
    const chartConceptionIds = chartConception
        .filter((c) => c.chartDimensionKey !== 'y')
        .map((c) => c.id);
    const columnKeys = columns.filter((c) => !c.isMetric).map((c) => c.key);

    if (columns.filter((c) => c.isMetric).length > 1) {
        columnKeys.push('metric');
    }
    // The chart conception can only work if all the conception columns are present in the chart
    return _.isEqual(
        chartConceptionIds.sort((a, b) => (a > b ? 1 : -1)),
        columnKeys.sort((a, b) => (a > b ? 1 : -1)),
    );
};

export const getIsChartConceptionEnabled = (
    settings: ChartSettingsT,
    columns: ResponseColumnT[],
    vizType: string,
) => {
    const { chartConception, secondaryYAxis } = settings;
    return (
        !secondaryYAxis &&
        conceptionAvailableVizTypes.includes(vizType) &&
        areConceptionColumnsCompatibleWithChart(chartConception, columns)
    );
};
